import React from "react"
import { Controller, useFormContext } from "react-hook-form"
import Select from "../Select"

export const OptionsFeedBackOfIncident = [
    {
        id: 1,
        label: "E-mail",
        value: "E-mail",
    },
    {
        id: 2,
        label: "Telefone",
        value: "Telefone",
    },
]

const SelectFeedBackInput = () => {
    const { control, formState: { errors } } = useFormContext()
    return (
        <Controller
            name="SelectFeedBack"
            control={control}
            render={({ field }) => (
                <Select
                    id="SelectFeedBack"
                    name="SelectFeedBack"
                    title="Como deseja receber as atualizações do pedido?"
                    placeholder="Escolha"
                    options={OptionsFeedBackOfIncident}
                    value={field.value?.value}
                    selected={field.value}
                    onChange={(e) => field.onChange(e.target.value)}
                    hasError={errors?.SelectFeedBack?.message}
                    errorMessage={errors?.SelectFeedBack?.message}
                    isRequired
                    {...field}
                />
            )}
        />
    )
}

export default SelectFeedBackInput